<template>
  <div class="circle">
    <communityHeader :router_url='router_url'></communityHeader>
    <div class="contentWidth">
      <div class="location"><span>中经视觉社区</span>><span>影展</span></div>
        <div class="bd of_h">
            <ul class="clearFix">
            <li class="fc_l"
                v-for="(item,index) in photo_data"
                :key="index">
                <div class="image" @click="addwork(item, index)">
                <!-- <img :src="item.coverUrl"
                    :alt="item.comments"
                    @click="addwork(item.photoshowId)"
                    class="cover_img"
                    v-if="item.coverUrl && item.coverUrl !==''"> -->
                    <others-photo-show :childData="item.workList" ></others-photo-show>
                <!-- <img src="@/assets/image/common/null_cover.png"
                    :alt="item.title"
                    @click="addwork(item.photoshowId)"
                    class="null_cover_img"
                    v-else> -->
                </div>
                <div class="photo-show-info">
                <div class="name mt_5"><span :title="item.title">{{item.title}}</span></div>
                <el-popover
                    placement="bottom"
                    trigger="click"
                    :visible-arrow="true"
                    popper-class="otherPhoto-show-share"
                    width="120"
                    v-if="item.status==1"
                    >
                    <div class="share" id="share">
                        <a href="javascript:;"
                        @click="share_qq(index)"
                        target="_blank"><i class="fa fa-qq"></i>QQ</a>
                        <a href="javascript:;"
                        @click="share_wb(index)"><i class="fa fa-weibo"></i>微博</a>
                        <a href="javascript:;"
                        class="sharewb">
                        <i class="fa fa-weixin"></i>微信
                        </a>
                        <div class="wecodeSp"
                            :id="`qrcodes${index}`"
                            :ref="`qrcodeContainers${index}`"
                        >
                        </div>
                    </div>
                    <el-button class="share-btn" slot="reference" icon="el-icon-share" @click.stop="shareClick(index)">分享</el-button>
                    </el-popover>
                </div>
            </li>
            </ul>

        </div>
    </div>

    <!-- <div class="contentWidth">
     
    </div> -->








  </div>
</template>
<script>
import { ta_PhotoShow } from '@/utils/api/ucenter.js'//用户信息
import othersPhotoShow from '@/components/swiper/othersPhotoShow.vue'
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import { Info } from '@/utils/api/login.js'

export default {
  name: 'communitycircle',
  data () {
    return {
      loading: true,
      error_login: require('@/assets/image/common/loading.gif'),
      photo_data:[],
    }
  },
  components: {
    communityHeader,
    loading,
    othersPhotoShow
  },
  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url
  },
  mounted () {
    this.other_ta_PhotoShow({userId: 'b467c0c988eb443ba1db0d15aeaf1444'})
  },

  methods: {
    other_ta_PhotoShow (params) {
      this.loading_bool = true;
      ta_PhotoShow(params).then((res) => {
        let data = res.data;
        this.photo_data = data.data
        console.log(this.photo_data);
        this.$nextTick(() => {
          this.photo_data.map((i, k) => {
            this.showQRCodes('qrcodes'+k, k);
          })
        })
        this.loading_bool = false;

      })
    },
  
    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
      })
    },
    // 生成为二维码
    showQRCodes (id, ind) {
      let that = this;
      setTimeout(() => {
        this.url = 'https://v.jingjiribao.cn/newcommunity' +'#' + `/PhotoShow?userId=${that.photo_data[ind].userId}&step=${ind}`
        let qrcode = new this.$QRCode(id, {
          text: this.url, //当前地址栏完整参数
          width: 100,
          height: 100,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: this.$QRCode.CorrectLevel.H
        });
      }, 1000);
    },
    //  分享到qq
    share_qq (ind) {
      const share = {
        title: this.photo_data[ind].title,
        desc: this.photo_data[ind].comments,
        share_url: window.location.href,
      };
      window.open("https://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(share.share_url) + "&title=" + share.title + "&desc=" + share.desc);
    },

    //  分享到微博
    share_wb (ind) {
      const share = {
        title: this.photo_data[ind].title,
        desc: this.photo_data[ind].comments,
        share_url: window.location.href,
      };
      window.open('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');
    },
    addwork (item, index) {
      this.$router.push({path:'/PhotoShow',query: {userId: item.userId, step: index}})
    },
  },
}
</script>
<style lang="scss" scoped="scoped">
.el-button--primary {
  color: #fff !important;
  background-color: #d4011a;
  border-color: #d4011a;
}
>>> .el-button:focus,
.el-button:hover {
  background: none !important;
}
>>>.el-button:hover i,>>>.el-button:hover span{
   color: #d4011a;
  //  transition: all 1s;

}
>>> .el-button {
  height: 40px;

  // float: right;
  border: none;
  background: none;
}
>>> .el-button span,>>> .el-button i {
  font-size: 14px;
  // color: #333;
  color: #606266;
  font-weight: 0;
}
.min_h_768 {
  padding-bottom: 50px;
}
.circlepage {
  padding: 0px 0 50px !important;
}

div.contentWidth {
    margin: 0 auto;
    // margin-top: 20px;
    // margin-bottom: 20px;
    // padding-bottom: 20px;
    border-radius: 10px;
    .location {
        height: .53rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: rgba(0,0,0,.25);
    }
    div.bd {
      padding: 0 20px;
      padding-bottom: 20px;
      min-height: 500px;
      ul {
        width: 100%;
        margin-top: -30px;
        padding-bottom: 20px;
        li {
          // width: 300px;
          width: 610px;
          box-sizing: border-box;
          margin-top: 30px;
          border-radius: 10px;
          // padding: 10px;
          // background: url(../../assets/image/community/imgbg.png) center 200px
          //   no-repeat #fff;
          // border: 1px #f1f1f1 solid;
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          transition: all 1s;
          &:hover {
            // box-shadow: 0px 5px 20px rgba(245, 183, 183, 0.2);
          }
          div.image {
            width: 100%;
            height: 494px;
            // background: url(../../assets/image/community/imgbg.png) center
            //   bottom no-repeat #fff;
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .cover_img {
            display: block;
            width: 100%;
            height: 488px;
            object-fit: cover;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          .cover_img:hover {
            opacity: 0.8;
            transition: all 0.1s linear 0s;
          }
          .null_cover_img {
            width: 100px;
            height: 100px;
          }
          .photo-show-info {
            background: rgb(255, 255, 255);
            border-bottom: 1px solid rgb(238, 238, 238);
            padding: 5px 16px 10px;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
            display: flex;
            align-items: center;
          }
          div.name,
          div.time {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            display: inline-block;
            width: 100%; 
            display: flex;
            // justify-content: space-between;
           
            span {
              max-width: calc(100% - 90px);
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap; 
              display: inline-block;
            }
            i{
              color: #c1c1c1;
              // font-style: italic;
              color: rgb(187, 187, 187);
              display: inline-block;
              max-width: 120px;
              font-size: 12px;
            }
          }
          div.time {
            font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei",
              "HanHei SC", "Helvetica Neue", "Open Sans", Arial,
              "Hiragino Sans GB", "微软雅黑", STHeiti, "WenQuanYi Micro Hei",
              SimSun, sans-serif;
            margin-top: 3px;
            color: rgb(187, 187, 187);
            font-size: 12px;
          }
          div.name:hover {
            color: #d4011a;
          }
        }
      }
    }
    div.UphotoShowpage {
      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/community/communityPhoto.vue